import type { AxiosInstance } from 'axios';
import { FirebaseAuth } from '../../FirebaseService/auth';
import { getClientForVersion } from '../utils';

let sessionClient: AxiosInstance | null = null;

function getSessionClient(): AxiosInstance {
  if (!sessionClient) {
    sessionClient = getClientForVersion(null);
  }
  return sessionClient;
}

export const sessionLogin = async (): Promise<void> => {
  await getSessionClient().post('/auth/login');
};

export const sessionRefresh = async (): Promise<void> => {
  await FirebaseAuth.getAuthToken(true);
  await getSessionClient().post('/auth/session/refresh');
};

export const sessionLogout = async (): Promise<void> => {
  await getSessionClient().post('/auth/logout');
};
